var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('vs-button',{attrs:{"color":"primary","type":"filled","size":"small","icon-pack":"feather","icon":"icon-external-link","target":"","href":_vm.params.value}},[_vm._v(" "+_vm._s(_vm.$t('$General.View'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }